/**
 * Search filtering for sections/custom-manual-library.liquid. Scoped per [data-manual-
 * library] root (not a global document query) so multiple instances on one page — or a
 * re-render via the theme editor's shopify:section:load — each get their own listeners
 * without duplicating or leaking across sections.
 */
;(function () {
	function initManualLibrary(root) {
		var input = root.querySelector('[data-manual-library-input]')
		if (!input) return

		var items = root.querySelectorAll('[data-manual-library-item]')
		var groups = root.querySelectorAll('[data-manual-library-group]')
		var emptyMessage = root.querySelector('[data-manual-library-empty]')

		input.addEventListener('input', function () {
			var term = input.value.trim().toLowerCase()
			var anyVisible = false

			items.forEach(function (item) {
				var isMatch = term === '' || item.dataset.search.indexOf(term) !== -1
				item.hidden = !isMatch
				if (isMatch) anyVisible = true
			})

			groups.forEach(function (group) {
				var hasVisibleItem = Array.prototype.some.call(
					group.querySelectorAll('[data-manual-library-item]'),
					function (item) {
						return !item.hidden
					},
				)
				group.hidden = !hasVisibleItem
			})

			if (emptyMessage) {
				emptyMessage.hidden = anyVisible || items.length === 0
			}
		})
	}

	function initAllManualLibraries() {
		document.querySelectorAll('[data-manual-library]').forEach(initManualLibrary)
	}

	document.addEventListener('shopify:section:load', initAllManualLibraries)
	initAllManualLibraries()
})()
